import React, { useEffect, useState } from 'react';
import { SingleSelect } from 'react-select-material-ui';
import { generateLabel } from '../../utils/helpers';
import useStyles from './styles';
import { Property } from '../../redux/types/properties';
import { usePermissions } from '../../hooks/usePermissions';

type Props = {
  properties: Property[];
  handleChange: (value: number, rest?: any) => void;
  activeFilter?: boolean,
};

const PropertySearch: React.FC<Props> = ({
  properties, handleChange, activeFilter = false
}) => {
  const classes = useStyles();
  const [currentProperties, setCurrentProperties] = useState<Property[]>(properties);

  const { canEdit } = usePermissions();

  useEffect(() => {
    if(activeFilter) {
      setCurrentProperties(properties.filter(property => ['PROPERTY_CREATED', 'PROPERTY_AVAILABLE', 'PROPERTY_STAFF_ACCESS'].includes(property.propStatus)));
    } else {
      setCurrentProperties(properties);
    }
  }, [properties, activeFilter]);

  return (
    <SingleSelect
      className={classes.root}
      label={generateLabel('Property')}
      disabled={!canEdit}
      options={currentProperties.map((property: {
        property_id: number,
        address_1: string,
        subdivision?: string,
        city?: string,
        state?: string,
        house_num?: string,
        zipcode?: string,
      }) => ({
        value: property.property_id,
        label: property.address_1,
        address: property.address_1,
        subdivision: property.subdivision,
        city: property.city,
        state: property.state,
        lot_number: property.house_num,
      }))}
      onChange={handleChange}
      // value={initialValue}
    />
  );
};

export default PropertySearch;
